import React, {useEffect} from "react";
import isMobile from "ismobilejs";
import ScrollReveal from "scrollreveal";
import gsap from "gsap";

export default function Chart() {

    useEffect(() => {
        const chart = document.querySelector('#Chart1 svg');

        window.addEventListener('scroll', () => {
            const chartRect = chart.getBoundingClientRect();

            if (chartRect.bottom <= window.innerHeight*1.2) {
                chart.classList.add('animate');
            }
        })
    }, []);

    const svg = `
<svg width="523px" height="292px" viewBox="0 0 523 292" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g  transform="translate(1.000000, 1.000000)">
            <text  font-family="DIN Next LT Pro, serif" font-size="16" font-weight="500" fill="#000000">
                <tspan x="14.016" y="272">eSports</tspan>
                <tspan x="67.984" y="272" font-size="20"></tspan>
            </text>
            <text  font-family="DIN Next LT Pro, serif" font-size="16" font-weight="500" fill="#000000">
                <tspan x="446.888" y="272">Appareils </tspan>
                <tspan x="452.592" y="288">mobiles </tspan>
            </text>
            <text  font-family="DIN Next LT Pro, serif" font-size="16" font-weight="500" fill="#000000">
                <tspan x="335.052" y="272">Hardware </tspan>
                <tspan x="335.796" y="288">PC gamer </tspan>
            </text>
            <text  font-family="DIN Next LT Pro, serif" font-size="16" font-weight="500" fill="#000000">
                <tspan x="218.252" y="272">PC gamer et </tspan>
                <tspan x="219.452" y="288">accessoires </tspan>
            </text>
            <text  font-family="DIN Next LT Pro, serif" font-size="16" font-weight="500" fill="#000000">
                <tspan x="86.272" y="272">Vidéos/contenus</tspan>
                <tspan x="104.184" y="288">sur les jeux</tspan>
            </text>
            <rect   fill="#32206C" x="0" y="218" width="82" height="8"></rect>
            <rect   fill="#32206C" x="109.75" y="181" width="82" height="45"></rect>
            <rect   fill="#32206C" x="219.5" y="165" width="82" height="61"></rect>
            <rect   fill="#32206C" x="329.25" y="31" width="82" height="195"></rect>
            <rect   fill="#32206C" x="439" y="26" width="82" height="200"></rect>
            <text  font-family="DIN Next LT Pro, serif" font-size="20" font-weight="bold" fill="#000000">
                <tspan x="237.19" y="156">12M$</tspan>
            </text>
            <text  font-family="DIN Next LT Pro, serif" font-size="20" font-weight="bold" fill="#000000">
                <tspan x="129.72" y="170">9,M$</tspan>
            </text>
            <text  font-family="DIN Next LT Pro, serif" font-size="20" font-weight="bold" fill="#000000">
                <tspan x="14.66" y="208">1,3M$</tspan>
            </text>
            <text  font-family="DIN Next LT Pro, serif" font-size="20" font-weight="bold" fill="#000000">
                <tspan x="338.1" y="20">39,3M$</tspan>
            </text>
            <text  font-family="DIN Next LT Pro, serif" font-size="20" font-weight="bold" fill="#000000">
                <tspan x="447.6" y="15">39,7M$</tspan>
            </text>
        </g>
    </g>
</svg>`;

    return (
        <div id={'Chart1'} dangerouslySetInnerHTML={{__html: svg}}/>
    )
}
